module.exports = __webpack_public_path__ + "assets/img/home.2901e268.png";